/** @format */

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import home from "./home.module.css";
import { useAuth } from "../context/AuthContext";

const Home = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser) {
      navigate("/profile-update")
    }
  }, [currentUser]);

  return (
    <div>
      {/* The header holds the background image */}
      <header className={home.header}></header>
      <div className={home.detailContainer}>
        <div className={home.details}>
          <div className={home.mainText}>
            <h1>
              STUDENT <br />
              E-PORTAL
            </h1>
            <p>
              view all school records of your child(ren) at the click of a
              button
            </p>
          </div>

          <p>powered by cloobTech - 2022</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
